import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import InvoiceDetails from './InvoiceDetails';
import {
  getInvoicesDetailsInitiate,
  getPaymentsForInvoiceInitiate,
} from '../../../../actions/company';
import { generateReportClear } from '../../../../actions/reports';
import { currentFlowTypeEnum } from '../../../common/components/constants';
import { openErrorToast } from '../../../../reducers/uiLogic';

const mapStateToProps = state => {
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const invoiceDetails = _get(state, 'company.invoiceDetails', {});
  const appliedDiscount = _get(invoiceDetails, 'applied_discount_details', {});
  const paymentsForInvoice = _get(state, 'company.invoicePayments', []);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    viewOnlyMode,
    currentFlow,
    invoiceDetails,
    appliedDiscount,
    fetchingInvoiceDetails:
      _get(state, 'apiState.GET_INVOICE_DETAILS.isFetching', true) &&
      !_get(state, 'apiState.GET_INVOICE_DETAILS.isIdle', false),
    fetchedInvoiceDetails: _get(
      state,
      'apiState.GET_INVOICE_DETAILS.success',
      true,
    ),
    paymentsForInvoice,
    fetchingPaymentsForInvoice:
      _get(state, 'apiState.GET_PAYMENTS_FOR_INVOICE.isFetching', true) &&
      !_get(state, 'apiState.GET_PAYMENTS_FOR_INVOICE.isIdle', false),
    fetchedPaymentsForInvoice: _get(
      state,
      'apiState.GET_PAYMENTS_FOR_INVOICE.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getInvoiceDetails: payload => dispatch(getInvoicesDetailsInitiate(payload)),
  getPaymentsForInvoice: payload =>
    dispatch(getPaymentsForInvoiceInitiate(payload)),
  showErrorToast: text => dispatch(openErrorToast(text)),
  clearGenerateReport: () => dispatch(generateReportClear()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InvoiceDetails);
